module.exports = __webpack_public_path__ + "img/8.6b2f12ed.jpg";